export default __webpack_public_path__ + "static/down-e350f24d7ac09bdd7516974ccdaf4c62.png";